
let deviceInfo =
  window.AndroidPlayerInterface && window.AndroidPlayerInterface.getDeviceInformation
    ? window.AndroidPlayerInterface.getDeviceInformation()
    : '{}';
deviceInfo = JSON.parse(deviceInfo);


export default {
  appKey: '376f137891510167c4d66b73bd0e517d', 
  appSubkey: 'androidtv',
  // Request params
  device_category: 'tv',
  device_id: deviceInfo.device_id, // como obtener device id
  device_manufacturer: 'androidtv',
  device_model: 'androidtv',
  device_name: 'androidtv', // como arman device Name
  device_so: deviceInfo.device_so, // como obtener device_so
  device_type: 'tv',
  stream_type: 'smooth_streaming',
  appversion: deviceInfo.appversion, // como obtener appversion
  firmwareversion: deviceInfo.firmwareversion, // como obtener firmware version,
  useEpgPostals: true,
  akamai_id: 'STBAndroid',
  nodetv: 'nagratv',
  hideArrowHeader: true,
  serial_id: deviceInfo.device_id || 'FF05E537L06',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwktv2-api.clarovideo.net' : 'http://mfwktv2-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/androidtv/config.js